import type { ReactNode } from 'react';

type Props = {
  titulo: string;
  descricao?: string;
  icone?: ReactNode;
};

export function EmptyState({ titulo, descricao, icone }: Props) {
  return (
    <div className="empty-state">
      {icone && <div className="empty-state__icon">{icone}</div>}
      <p className="empty-state__title">{titulo}</p>
      {descricao && <p>{descricao}</p>}
    </div>
  );
}
